import React from "react";
import {connect} from "react-redux";
import Team from "./Team";
import {
    addItemAction,
    changeQuantityAction,
    delPositionAction,
    setPositionAction,
    updatePositionsListAction
} from "../../../redux/team-reducer";
import {changeStepAction, scrollToStepAction, setNextStepAction} from "../../../redux/flow-reducer";

const mapStateToProps = state => {

    let obj = {
        team:state.team,
        flow:state.flow
    }

    return obj;
}

const mapDispatchToProps = dispatch => {

    let obj = {
        addItem: ()                     => {dispatch(addItemAction());},
        setPosition: (e, data)          => {dispatch(setPositionAction(e, data));},
        changeQuantity: (dataId, act)   => {dispatch(changeQuantityAction(dataId, act));},
        delPosition: (dataId)           => {dispatch(delPositionAction(dataId));},
        setNextStep: (nextStep)         => {dispatch(setNextStepAction(nextStep));},
        updatePositionsList: (list)     => {dispatch(updatePositionsListAction(list));},
        changeStep: ()                  => {dispatch(changeStepAction());},
        scrollToStep: (stepId)          => {dispatch(scrollToStepAction(stepId));}
    }

    return obj;
}

const TeamContainer = connect(mapStateToProps, mapDispatchToProps)(Team);

export default TeamContainer;